'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar, Button } from '@common/components';
import { SvgLike, SvgLikeFill, SvgWelloHelperMark } from '@common/icon';
import { useState } from 'react';
import type { Comment } from '@/api/getCommentList';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES, SELECTOR } from '@/constants';
import SvgBestIcon from './_assets/best.svg';
import SvgPickedIcon from './_assets/picked.svg';
import { CommentMenu, type CommentMenuProps } from './CommentMenu';
interface CommentCardProps {
  comment: Comment;
  onClickLikeButton?: () => void;
  onClickReplyButton?: () => void;
  children?: React.ReactNode;
  initialChildrenOpened?: boolean;
  onClickEditButton?: CommentMenuProps['onClickEditButton'];
  onDeleteSuccess?: CommentMenuProps['onDeleteSuccess'];
  onClickPickButton?: () => void;
  hasMenu?: boolean;
  hasPickButton?: boolean;
}
export const CommentCard = t0 => {
  const $ = _c(32);
  const {
    onClickLikeButton,
    onClickReplyButton,
    comment,
    children,
    initialChildrenOpened,
    hasMenu,
    onClickEditButton,
    onDeleteSuccess,
    onClickPickButton,
    hasPickButton
  } = t0;
  const hasRelativePolicy = comment.hasRelativePolicy;
  const [isChildrenOpened, setIsChildrenOpened] = useState(comment.hasRelativePolicy || initialChildrenOpened);
  const [isRelativePolicyOpened, setIsRelativePolicyOpened] = useState(true);
  const {
    parentNickName,
    contents
  } = comment;
  const isHiddenComment = comment.isBlocked || comment.isDeleted || comment.isReport || !comment.isDisplay;
  const hasBadge = comment.isBest || comment.isPicked;
  const id = SELECTOR.COMMENT_PREFIX + comment.commentId;
  let t1;
  if ($[0] !== children || $[1] !== comment.commentId || $[2] !== comment.contents || $[3] !== comment.createdAt || $[4] !== comment.isBest || $[5] !== comment.isMine || $[6] !== comment.isMyThumbUp || $[7] !== comment.isPicked || $[8] !== comment.isWelloHelper || $[9] !== comment.nickname || $[10] !== comment.profileImage || $[11] !== comment.relationPolicyList || $[12] !== comment.thumbUpCount || $[13] !== contents || $[14] !== hasBadge || $[15] !== hasMenu || $[16] !== hasPickButton || $[17] !== hasRelativePolicy || $[18] !== id || $[19] !== isChildrenOpened || $[20] !== isHiddenComment || $[21] !== isRelativePolicyOpened || $[22] !== onClickEditButton || $[23] !== onClickLikeButton || $[24] !== onClickPickButton || $[25] !== onClickReplyButton || $[26] !== onDeleteSuccess || $[27] !== parentNickName) {
    t1 = isHiddenComment ? <article className="relative flex w-full items-center justify-center rounded-xsmall bg-Gray-50 p-10 text-center text-Gray-500 typo-body4" id={id}>{comment.contents}{children ? <Button className="absolute right-10 font-400 text-Gray-700 typo-caption1" dimensions="H26" theme="sub-text" onClick={() => setIsChildrenOpened(_temp)}>{isChildrenOpened ? "\uB2F5\uAE00\uC811\uAE30" : "\uB2F5\uAE00\uBCF4\uAE30"}</Button> : null}</article> : <article className="flex gap-10 overflow-hidden bg-Gray-white" id={id}><Avatar alt={`${comment.nickname} 프로필`} src={comment.profileImage} /><section className="flex flex-1 flex-col gap-4"><header className="flex justify-between"><section className="flex w-full flex-col gap-8"><div className="flex w-full items-center gap-6"><span className="font-500 text-Gray-900 typo-body4">{comment.nickname}</span>{comment.isWelloHelper ? <SvgWelloHelperMark originalFill={true} className="size-16" /> : null}<time className="text-Gray-700 typo-caption1">{comment.createdAt}</time><div className="ml-auto flex-center">{hasPickButton && comment.isWelloHelper ? <Button className="text-B-500 !typo-caption1" dimensions="H26" theme="sub-text" onClick={onClickPickButton}>답변채택</Button> : null}{hasMenu ? <CommentMenu commentId={comment.commentId} isMyComment={comment.isMine} onDeleteSuccess={onDeleteSuccess} onClickEditButton={onClickEditButton} /> : null}</div></div>{hasBadge ? <ul className="flex gap-4">{comment.isBest ? <li className="flex size-fit items-center justify-center gap-4 rounded-xxsmall bg-Y-100 px-6 py-2 text-Y-800 typo-caption1"><SvgBestIcon className="size-12" />베스트댓글</li> : null}{comment.isPicked ? <li className="flex size-fit items-center justify-center gap-4 rounded-xxsmall bg-Y-100 px-6 py-2 text-Y-800 typo-caption1"><SvgPickedIcon className="size-12" />채택된 답변</li> : null}</ul> : null}</section></header><section className="whitespace-pre-wrap break-all text-Gray-800 typo-body4">{parentNickName ? <span className="mr-8 text-B-500">@{parentNickName}</span> : null}{contents}</section><footer className="flex justify-between gap-8 pt-4"><div className="flex h-fit items-center gap-16 leading-5"><button aria-label={"\uC88B\uC544\uC694"} className="group flex gap-4 font-400 text-Gray-700 typo-caption1" type="button" onClick={onClickLikeButton}>{comment.isMyThumbUp ? <SvgLikeFill className="mt-2 size-14 text-B-500" /> : <SvgLike className="mt-2 size-14 text-Gray-500" />}좋아요 {comment.thumbUpCount}</button><button aria-label={"\uB2F5\uAE00"} className="font-400 text-Gray-700 typo-caption1" type="button" onClick={onClickReplyButton}>답글쓰기</button></div>{children && !hasRelativePolicy ? <button className="font-400 text-Gray-700 typo-caption1" type="button" onClick={() => setIsChildrenOpened(_temp2)}>{isChildrenOpened ? "\uB2F5\uAE00\uC811\uAE30" : "\uB2F5\uAE00\uBCF4\uAE30"}</button> : null}{hasRelativePolicy ? <button className="font-600 text-Gray-700 typo-caption1" type="button" onClick={() => setIsRelativePolicyOpened(_temp3)}>{isRelativePolicyOpened ? "\uAD00\uB828\uC815\uCC45 \uC811\uAE30" : "\uAD00\uB828\uC815\uCC45 \uBCF4\uAE30"}</button> : null}</footer>{isRelativePolicyOpened && hasRelativePolicy ? <ul className="my-16 flex w-full flex-col gap-8">{comment.relationPolicyList.map(_temp4)}</ul> : null}</section></article>;
    $[0] = children;
    $[1] = comment.commentId;
    $[2] = comment.contents;
    $[3] = comment.createdAt;
    $[4] = comment.isBest;
    $[5] = comment.isMine;
    $[6] = comment.isMyThumbUp;
    $[7] = comment.isPicked;
    $[8] = comment.isWelloHelper;
    $[9] = comment.nickname;
    $[10] = comment.profileImage;
    $[11] = comment.relationPolicyList;
    $[12] = comment.thumbUpCount;
    $[13] = contents;
    $[14] = hasBadge;
    $[15] = hasMenu;
    $[16] = hasPickButton;
    $[17] = hasRelativePolicy;
    $[18] = id;
    $[19] = isChildrenOpened;
    $[20] = isHiddenComment;
    $[21] = isRelativePolicyOpened;
    $[22] = onClickEditButton;
    $[23] = onClickLikeButton;
    $[24] = onClickPickButton;
    $[25] = onClickReplyButton;
    $[26] = onDeleteSuccess;
    $[27] = parentNickName;
    $[28] = t1;
  } else {
    t1 = $[28];
  }
  const t2 = isChildrenOpened ? children : null;
  let t3;
  if ($[29] !== t1 || $[30] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  return t3;
};
function _temp(prev) {
  return !prev;
}
function _temp2(prev_0) {
  return !prev_0;
}
function _temp3(prev_1) {
  return !prev_1;
}
function _temp4(policy) {
  return <li key={policy.metaPolicyIdIdx}><CustomLink className="flex items-center gap-12 rounded-small border border-Gray-300 px-12 py-8" href={ROUTES.POLICY_DETAIL.pathname({
      idIdx: policy.metaPolicyIdIdx
    })}><div className="relative size-36 overflow-hidden rounded-small border border-Gray-300 p-4"><Image alt={`${policy.policyName} 기관 로고`} className="object-contain" fill={true} sizes="36px" src={policy.agencyLogo} /></div><strong className="w-0 flex-1 overflow-hidden truncate font-500 text-Gray-900 typo-body4">{policy.policyName}</strong></CustomLink></li>;
}